import React from "react";

const LoadingComponent = () => {
    return (
        <>
        {/* <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
            }}
        >
            <CircularProgress color="primary" style={{ fill:"#22419e" }} size={50} />
            <span style={{ marginLeft: "10px" }}>Loading...</span>
        </div> */}
        </>
    );
};

export default LoadingComponent;
